import { FinanceModel, PeripheralFinanceModel } from '@/services/api/contracts/financemodels';
import { useCataloguePCMPrice } from '@/services/catalogue/useCataloguePCMPrice';
import { FunctionComponent } from 'react';

interface PCMFieldProps {
  model: FinanceModel | PeripheralFinanceModel;
  price: number;
  regionCode?: string;
}

const CataloguePCMField: FunctionComponent<PCMFieldProps> = ({ model, price, regionCode }) => {
  const pcmPrice = useCataloguePCMPrice(price, regionCode, model);

  return (
    <div className="space-x-2">
      <span className="text-xs opacity-50">•</span>
      <span className="text-sm">{pcmPrice} pcm</span>
    </div>
  );
};

export default CataloguePCMField;
